import React from 'react'

const TopNavigationLayout: React.FC<React.PropsWithChildren> = ({
  children,
}) => {
  return <div className="top_navigation_layout">{children}</div>
}

export default TopNavigationLayout
